<template>
    <div  role="status" class="inline items-start justify-center w-full px-4 py-3">
        <div class="flex items-center justify-center shadow-xl bg-gray-300 w-full h-56 animate-pulse ">
            <!-- <div class="px-4 py-2 bg-gray-400 flex items-center justify-center">
                <span class="sr-only">Loading...</span>
                <svg class="w-6 h-6 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 384 512"><path d="M361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215z"/></svg>
            </div> -->
        </div>
        <div class="w-full h-20 py-3">
            <div class="h-3 bg-gray-200 rounded-full w-full mb-2.5"></div>
            <div class="h-3 bg-gray-200 rounded-full w-[100px]"></div>
        </div>
        <span class="sr-only">Loading...</span>
    </div>
</template>

<script>
    export default {
        name: 'VideoSkeletonComponent',
        data() {
            return {
                hover: false
            }
        },
    }
</script>